import * as React from "react";
import { fetchWithToken, BackendFailureAlert } from "@platform/core";
import {
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  setTheme,
  Typography,
} from "@platform/style";
import { HEADERBFF_URL } from "../constants";

interface Preferences {
  CompanyId: string;
  Id: string;
  Theme: string;
  UserId: string;
}

interface AccountSettingsProps {
  preferencesId: string;
}

export default function AccountSettings(props: AccountSettingsProps) {
  const [colorMode, setColorMode] = React.useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "Light"
  );
  const [appearanceError, setAppearanceError] = React.useState(false);
  const [errorLog, setErrorLog] = React.useState<any>(null);
  const [correlationId, setCorrelationId] = React.useState<any>(null);
  const handleColorModeChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const options: RequestInit = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Theme: (event.target as HTMLInputElement).value,
        }),
      };
      const response = await fetchWithToken(
        `${HEADERBFF_URL}/v1/preferences/${props.preferencesId}`,
        options
      );

      if (!response.ok) {
        setCorrelationId(response.headers.get("x-correlation-id"));
        throw new Error(JSON.stringify(response));
      } else {
        setCorrelationId(response.headers.get("x-correlation-id"));
        const decoded = (await response.json()) as Preferences;
        if (decoded.Theme === "Light" || decoded.Theme === "Dark" || decoded.Theme === "Auto") {
          setColorMode((event.target as HTMLInputElement).value);
          setTheme(decoded.Theme);
        } else {
          setTheme("Auto");
          setColorMode("Auto");
        }
        setAppearanceError(false);
      }
    } catch (err: any) {
      setErrorLog(err.stack?.toString().replace(/[\n\r]/g, ""));
      setAppearanceError(true);
    }
  };

  return (
    <>
      <Paper elevation={0}>
        <Typography marginTop="20px" display="block" variant={"OptionName"}>
          Appearance
        </Typography>
        {appearanceError ? (
          <BackendFailureAlert
            failures={[
              {
                message: "Error communicating with backend",
                component: "AccountSettings",
                exceptionInformation: errorLog,
                correlationId: correlationId,
              },
            ]}
          />
        ) : (
          <FormControl>
            <RadioGroup
              value={colorMode}
              onChange={handleColorModeChange}
              row
              aria-labelledby="color-mode-row-radio-buttons"
              name="color-mode-radio-buttons-group"
            >
              <FormControlLabel
                value="Auto"
                control={<Radio />}
                label={<Typography variant="RadioLabel">Auto</Typography>}
                data-testid={colorMode == "Auto" ? "CheckedAutoLabel" : "UncheckedAutoLabel"}
              />
              <FormControlLabel
                value="Light"
                control={<Radio />}
                label={<Typography variant="RadioLabel">Light</Typography>}
                data-testid={colorMode == "Light" ? "CheckedLightLabel" : "UncheckedLightLabel"}
              />
              <FormControlLabel
                value="Dark"
                control={<Radio />}
                label={<Typography variant="RadioLabel">Dark</Typography>}
                data-testid={colorMode == "Dark" ? "CheckedDarkLabel" : "UncheckedDarkLabel"}
              />
            </RadioGroup>
          </FormControl>
        )}
      </Paper>
    </>
  );
}
